module.exports = __webpack_public_path__ + "media/fun/fun-6-458c9b4b.jpg";